// extracted by mini-css-extract-plugin
export default {"StatusChipWrapper":"StatusChipWrapperiFhhg","statusChipWrapper":"StatusChipWrapperiFhhg"};